import React, { useState } from "react";
import {
  Box,
  Container,
  Typography,
  TextField,
  Tooltip,
  Grid,
  Select,
  MenuItem,
  FormControl,
  Paper,
  InputLabel,
} from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import SendIcon from "@mui/icons-material/Send";
import FooterButtons from "./FooterButtons";
import {
  globalPaperBackgroundColor,
  globalInputField,
} from "../components/constants";

const ContactUsForm = () => {
  const [email, setEmail] = useState("");
  const [queryType, setQueryType] = useState("");
  const [mailContent, setMailContent] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handleQueryTypeChange = (event) => {
    setQueryType(event.target.value);
  };

  const handleMailContentChange = (event) => {
    setMailContent(event.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    // Learn more at https://support.apple.com/en-in/102525

    // Send email to support@astrodata.app
    const emailData = {
      email: email,
      queryType: queryType,
      mailContent: mailContent,
    };

    console.log("Sending email to support@astrodata.app:", emailData);

    // Clear form fields after submission
    setEmail("");
    setQueryType("");
    setMailContent("");
    setIsLoading(false);
  };

  const isSubmitDisabled = () => {
    return !email || !queryType || !mailContent;
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          marginTop: "0%",
          marginBottom: "1%",
          justifyContent: "center",
          alignItems: "center",
          padding: { xs: "1rem", sm: "2rem" },
          flexWrap: "wrap",
          "& > :not(style)": {
            width: "100%",
          },
          "@media (min-width:600px)": {
            "& > :not(style)": {
              width: "78%",
            },
          },
          "@media (min-width:960px)": {
            "& > :not(style)": {
              width: "64%",
            },
          },
        }}
      >
        <Paper
          elevation={3}
          sx={{
            padding: { xs: "1rem", sm: "2rem" },

            backgroundColor: globalPaperBackgroundColor,
          }}
        >
          <Container maxWidth="sm">
            <Typography variant="h4" gutterBottom>
              Contact Us
            </Typography>
            <Typography variant="body1" paragraph>
              Please feel free to contact us. We are more than happy to help
              with any questions or concerns you may have.
            </Typography>
            <Typography variant="body1" paragraph>
              Email:{" "}
              <a href="mailto:support@astrodata.app">support@astrodata.app</a>
            </Typography>
            <form onSubmit={handleSubmit}>
              <TextField
                label="Email Address"
                variant="outlined"
                fullWidth
                margin="normal"
                value={email}
                onChange={handleEmailChange}
                sx={{ backgroundColor: globalInputField }}
                required
              />
              <FormControl
                fullWidth
                variant="outlined"
                margin="normal"
                required
              >
                <InputLabel>Query Type</InputLabel>
                <Select
                  value={queryType}
                  onChange={handleQueryTypeChange}
                  label="Query Type"
                  sx={{ backgroundColor: globalInputField }}
                >
                  <MenuItem value="General Inquiry">General Inquiry</MenuItem>
                  <MenuItem value="Technical Support">
                    Technical Support
                  </MenuItem>
                  <MenuItem value="Billing">Billing</MenuItem>
                  <MenuItem value="Other">Other</MenuItem>
                </Select>
              </FormControl>
              <TextField
                label="Content"
                multiline
                rows={4}
                variant="outlined"
                fullWidth
                margin="normal"
                value={mailContent}
                onChange={handleMailContentChange}
                required
                sx={{ backgroundColor: globalInputField }}
              />
              <Grid item xs={12}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    marginTop: "20px",
                  }}
                >
                  <Tooltip
                    title={
                      isSubmitDisabled()
                        ? "Fill all required details to enable send button"
                        : ""
                    }
                  >
                    <span>
                      <LoadingButton
                        variant="contained"
                        color="primary"
                        onClick={handleSubmit}
                        loading={isLoading}
                        disabled={isSubmitDisabled() || isLoading} // Disable the button when loading
                        endIcon={<SendIcon />}
                        loadingPosition="end"
                      >
                        Send
                      </LoadingButton>
                    </span>
                  </Tooltip>
                </Box>
              </Grid>
            </form>
          </Container>
        </Paper>
      </Box>
      <FooterButtons />
    </>
  );
};

export default ContactUsForm;
